///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {
    import PackageType = Model.PackageType;


    export class PackageTypesCollection extends SmartMoverApiCollection<PackageType> implements IApiCollection<PackageType> {

        get url() {
            return 'PackageType';
        }

        constructor(connectedModel: ModelValueType[], items: PackageType[] = [], options: ICollectionOptions<PackageType> = {}) {
            super(connectedModel, items, options);
        }
    }

}